export type RenderStyles = {
  frameStrokeWidthMM: number;
  sashTypeIndicatorStrokeWidthMM: number;
  sashTypeIndicatorArrowScale: number;
  dimensionGuidelines: 'edit' | 'readOnly' | 'none';
  frameDimensionLineOffset: {
    topMM: number;
    bottomMM: number;
    leftMM: number;
    rightMM: number;
  };
  areaDimensionLineOffset: {
    topMM: number;
    bottomMM: number;
    leftMM: number;
    rightMM: number;
  };
  stagePadding: number;
  caption: {
    textScale: number;
    textSize: number;
    textPadding: number;
  };
};

const editorStyles: RenderStyles = Object.freeze({
  frameStrokeWidthMM: 2,
  sashTypeIndicatorStrokeWidthMM: 2,
  sashTypeIndicatorArrowScale: 1,
  dimensionGuidelines: 'edit',
  frameDimensionLineOffset: {
    topMM: 0,
    bottomMM: 200,
    leftMM: 200,
    rightMM: 200,
  },
  areaDimensionLineOffset: {
    topMM: 0,
    bottomMM: 200,
    leftMM: 200,
    rightMM: 0,
  },
  stagePadding: 20,
  caption: {
    textScale: 1,
    textSize: 16,
    textPadding: 8,
  },
});

const readOnlyStyles: RenderStyles = Object.freeze({
  frameStrokeWidthMM: 3,
  sashTypeIndicatorStrokeWidthMM: 5,
  sashTypeIndicatorArrowScale: 3,
  dimensionGuidelines: 'readOnly',
  frameDimensionLineOffset: {
    topMM: 0,
    bottomMM: 200,
    leftMM: 200,
    rightMM: 200,
  },
  areaDimensionLineOffset: {
    topMM: 0,
    bottomMM: 200,
    leftMM: 200,
    rightMM: 0,
  },
  stagePadding: 100,
  caption: {
    textScale: 0.5,
    textSize: 32,
    textPadding: 12,
  },
});

const presetSelectorStyles: RenderStyles = Object.freeze({
  frameStrokeWidthMM: 3,
  sashTypeIndicatorStrokeWidthMM: 8,
  sashTypeIndicatorArrowScale: 3,
  dimensionGuidelines: 'none',
  frameDimensionLineOffset: {
    topMM: 0,
    bottomMM: 0,
    leftMM: 0,
    rightMM: 0,
  },
  areaDimensionLineOffset: {
    topMM: 0,
    bottomMM: 0,
    leftMM: 0,
    rightMM: 0,
  },
  stagePadding: 0,
  caption: {
    textScale: 1,
    textSize: 32,
    textPadding: 12,
  },
});

export const getOffsets = (styles: RenderStyles) => {
  return {
    leftMM:
      styles.frameDimensionLineOffset.leftMM +
      styles.areaDimensionLineOffset.leftMM +
      styles.stagePadding,
    rightMM:
      styles.frameDimensionLineOffset.rightMM +
      styles.areaDimensionLineOffset.rightMM +
      styles.stagePadding,
    topMM:
      styles.frameDimensionLineOffset.topMM +
      styles.areaDimensionLineOffset.topMM +
      styles.stagePadding,
    bottomMM:
      styles.frameDimensionLineOffset.bottomMM +
      styles.areaDimensionLineOffset.bottomMM +
      styles.stagePadding,
  };
};

export const useRenderStyles = (
  mode: 'editor' | 'readOnly' | 'presetSelector'
) => {
  if (mode === 'editor') return editorStyles;
  if (mode === 'readOnly') return readOnlyStyles;

  return presetSelectorStyles;
};
